import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import Vuebar from 'vuebar';
import './plugins/base';
import VueSkycons from 'vue-skycons';
import VuePapaParse from 'vue-papa-parse';

//PLUGIN ENIGMA4X
import httpService4X from './services/httpInstallService';

Vue.use(httpService4X, { token: true, name: 'token' });
Vue.use(VuePapaParse);

Vue.use(VueSkycons, {
  color: '#1e88e5'
});

Vue.use(Vuebar);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  store,
  router,
  render: (h) => h(App)
}).$mount('#app');
